<template>
   <div class="float-btn l-icon l-icon-help">
    <div class="mini-menu-Overall ">
        <div class="mini-menu-Overall-item " >新手指南</div>
        <div class="mini-menu-Overall-item " >视频教程</div>
        <!-- <div class="mini-menu-Overall-item " >文档教程</div> -->
    </div>
   </div>
</template>

<script>

export default {
    name: 'GuideCourse',
    mounted() {
        this.video_Tutorial_btn()
        // 设置悬浮入口的初始位置
        this.setWxServiceBtnPosition()
        
    },
    methods: {
        
        video_Tutorial_btn() {
            var that = this
            var menuDisplay = false
            var flag = true
            var timer
            // var html = []
            // html.push(' <div class="float-btn l-icon l-icon-help">')
            // html.push('<div class="mini-menu-Overall ">')
            // html.push('<div class="mini-menu-Overall-item " >新手指南</div>')
            // html.push('<div class="mini-menu-Overall-item " >视频教程</div>')
            // // html.push(' <div class="mini-menu-Overall-item " >文档教程</div>')
            // html.push('</div>')
            // html.push('</div>')

            // $('body').append(html.join(''))
            

            $('.mini-menu-Overall-item').click(function (event) {
                window.event ? (window.event.cancelBubble = true) : event.stopPropagation()
                // 获取被点击的元素的文本内容
                var clickedText = $(this).text().trim(); // 获取文本内容
                const map = {
                    '新手指南': "beginnersGuideEntrance",
                    '视频教程': "videoTutorial"
                }
                if (event.target == this) {
                    Jumparound(clickedText)
                }
                window.lib && window.lib.track.tap(map[clickedText], "Main", { pageName: "lanqiao_saas_home" });
            })

            iconBorder()

            //图标移动方法
            $('.float-btn').ligerDrag &&
                $('.float-btn').ligerDrag({
                    proxy: false,
                    clickDelay: 200,

                    //开始移动事件
                    onStartDrag: function () {
                        //移动状态下不弹出菜单组件
                        flag = false
                        $('.mini-menu-Overall').hide()
                    },

                    //移动结束事件
                    onStopDrag: function (start, end) {
                        var rightDistance = document.documentElement.clientWidth
                        var btn = $('.float-btn').offset().left
                        var btnTop = $('.float-btn').offset().top
                        var width = $('.float-btn').width()

                        //移动结束后判断是否靠浏览器右边边界
                        if (btn + width + 5 >= rightDistance) {
                            //靠近边界
                            $('.float-btn').css({
                                left: rightDistance - 40 * 0.6,
                                opacity: '.6'
                            })
                            menuDisplay = false
                            that.setAllFloatPosition({
                                clientX: rightDistance - 40 * 0.6,
                                clientY: end.clientY
                            })
                        } else {
                            //移出边界了,图标让正常使用
                            $('.float-btn').css({
                                opacity: '1'
                            })
                            menuDisplay = true
                            flag = true
                            that.setAllFloatPosition({
                                clientX: btn,
                                clientY: btnTop
                            })
                        }
                    }
                })

            //鼠标移入图标事件
            $('.float-btn').mouseover(function () {
                if (menuDisplay && flag) {
                    //0.5秒后弹出菜单组件
                    timer = setTimeout(function () {
                        //移动状态下不弹出菜单组件
                        if (!flag) {
                            clearTimeout(timer)
                            return
                        }
                        $('.mini-menu-Overall').show()
                        newUserGuideExposure()
                        $('.mini-menu-Overall').css({ top: -22, left: -110 })
                    }, 200)
                }

                // 只有在初始位置的时候，才会有这个弹出的动作
                const floatGuideEntrancePosition = JSON.parse(top.window.sessionStorage.getItem('floatGuideEntrancePosition'))
                // 如果是从靠右的初始位置移入，有个弹出的动作
                if (!menuDisplay) {
                    var rightDistance = document.documentElement.clientWidth - 50
                    if (!floatGuideEntrancePosition || rightDistance < floatGuideEntrancePosition.left) {
                        $('.float-btn').css({
                            left: rightDistance,
                            opacity: '1'
                        })
                    } else {
                        $('.float-btn').css({
                            opacity: '1'
                        })
                    }

                    menuDisplay = true
                    flag = true
                }
            })

            // 鼠标移开图标事件
            $('.float-btn').mouseleave(function () {
                if (menuDisplay && flag) {
                    clearTimeout(timer)
                }
            })

            //窗口大小改变
            $(window).resize(function () {
                winChange()
            })

            // 点击其它位置隐藏弹出来的选择列表
            $(window).click(function () {
                $('.mini-menu-Overall').hide()
            })

            //浏览器窗口大小改变后的回调
            function winChange() {
                var rightDistanceR = document.documentElement.clientWidth
                var btnR = $('.float-btn').offset().left
                if (btnR + 40 >= rightDistanceR) {
                    //贴近右边浏览器边界时

                    $('.float-btn').css({
                        left: rightDistanceR - 40 * 0.6,
                        opacity: '.6'
                    })
                    menuDisplay = false
                } else if (btnR > rightDistanceR) {
                    //图标移动距离大于浏览器大小时

                    $('.float-btn').css({
                        left: rightDistanceR - 40 * 0.6,
                        opacity: '.6'
                    })
                    menuDisplay = false
                } else if (!menuDisplay) {
                    //图标没被移动出来，让图标一直贴着

                    // 判断是否是初始化，如果是初始化情况，则放置在初始化的位置(开多个tab的刷新的时候，切换tab会触发该事件)
                    const floatGuideEntrancePosition = JSON.parse(top.window.sessionStorage.getItem('floatGuideEntrancePosition'))
                    if (floatGuideEntrancePosition && floatGuideEntrancePosition.left < rightDistanceR - 50) {
                        $('.float-btn').css({
                            left: floatGuideEntrancePosition.left,
                            top: floatGuideEntrancePosition.top,
                            opacity: '.6'
                        })
                    } else {
                        $('.float-btn').css({
                            left: rightDistanceR - 40 * 0.6,
                            opacity: '.6'
                        })
                    }
                    menuDisplay = false
                } else {
                    //图标已被移动出来
                    $('.float-btn').css({
                        opacity: '1'
                    })
                    //menuDisplay ，图标移动出来后，停留在图标上可以让图标弹出菜单组件
                    menuDisplay = true
                }
            }
            // 新手指南曝光
            function newUserGuideExposure() {
                window.lib && window.lib.track.view("beginnersGuideEntrance", "Main", {
                pageName: "lanqiao_saas_home",
                });
            }

            //双击弹出菜单栏
            $('.float-btn').dblclick(function (event) {
                window.event ? (window.event.cancelBubble = true) : event.stopPropagation()
                if (menuDisplay) {
                    $('.mini-menu-Overall').show()
                    newUserGuideExposure()
                }
            })

            //隐藏图标函数
            function iconBorder() {
                var width = $('.float-btn').width()
                $('.float-btn').css({
                    right: width * -0.4,
                    opacity: '.6'
                })
            }

            //跳转tab
            function Jumparound(text) {
                
                var list = [{ text: '新手指南', url: 'NewUSerGuideTutorial' },{ text: '视频教程', url: 'VideoTutorial' },]
                //var index = list.findIndex(item => item.text == text);
                const item = list.find(item => item.text == text);
                if (!item) return

                console.log('Jumparound',item)
                var form = location.pathname.replace(window.__lq_base_url, '')
                // if (!top.$('#' + list[index].url).length) {
                //     top.f_addTab(list[index].url, text, getEVNUrlByWhitelist('/zyDownload/' + list[index].url + '?form=' + form))
                // } else {
                //     top.liger.get('framecenter').selectTabItem(list[index].url)
                //     if (list[index].url == 'VideoTutorial') {
                //         top.frames[list[index].url].refreshData(form)
                //     }
                    
                // }
                if (!top.$('#' + item.url).length) {
                    top.f_addTab(item.url, text, getEVNUrlByWhitelist('/zyDownload/' + item.url + '?form=' + form))
                } else {
                    top.liger.get('framecenter').selectTabItem(item.url)
                    if (item.url == 'VideoTutorial') {
                        top.frames[item.url].refreshData(form)
                    }
                    
                }
                
                $('.mini-menu-Overall').hide()

                // var form = location.pathname.replace(window.__lq_base_url, '')

                // if (!top.$('#VideoTutorial').length) {
                //     top.f_addTab('VideoTutorial', '视频教学', getEVNUrlByWhitelist('/zyDownload/VideoTutorial?form=' + form))
                // } else {
                //     top.liger.get('framecenter').selectTabItem('VideoTutorial')
                //     top.frames['VideoTutorial'].refreshData(form)
                // }

                // $('.mini-menu-Overall').hide()
            }
        },

        // 手动修改所有的位置
        setWxServiceBtnPosition() {
            const floatGuideEntrancePosition = JSON.parse(top.window.sessionStorage.getItem('floatGuideEntrancePosition'))
            if (floatGuideEntrancePosition) {
                $('.float-btn').css({
                    left: floatGuideEntrancePosition.left,
                    top: floatGuideEntrancePosition.top
                })
            }
        },

        // 设置其他iframe中元素位置
        setAllFloatPosition(end) {
            top.window.sessionStorage.setItem(
                'floatGuideEntrancePosition',
                JSON.stringify({
                    left: end.clientX,
                    top: end.clientY
                })
            )
            var allIframe = top.document.getElementsByTagName('iframe')
            for (let index = 0; index < allIframe.length; index++) {
                const element =
                    allIframe[index] &&
                    allIframe[index].contentDocument &&
                    allIframe[index].contentDocument.getElementsByClassName('float-btn') &&
                    allIframe[index].contentDocument.getElementsByClassName('float-btn')[0]
                if (element && end) {
                    $(element).css({
                        left: end.clientX,
                        top: end.clientY
                    })
                }
            }
        }
    }
}
</script>

<style></style>
